module.exports = __webpack_public_path__ + "img/WaitingTurtle.e56d4163.svg";